export const DOCUMENT_TYPES = {
	afc_privacy_policy: 'afc_privacy_policy',
};

export const SIGNUP_ERROR_MESSAGES = {
	EXISTING_OPENLANE_ACCOUNT: 'This email address is associated with an existing OPENLANE account',
	EMAIL_ALREADY_TAKEN: 'Email has already been taken',
};

export const LANGUAGE_CODES = {
	english: 0,
	spanish: 1,
};

export const UI_STATE = {
	ready: 0,
	nextInProgress: 1,
	backInProgress: 2,
	error: 3,
};

export const SIGNUP_PATH_IDS = {
	standardPath: 'std',
	privateLabelPath: 'plp',
	partnerFastPath: 'pfp',
	standardPartnerPath: 'sfp',
	internalSalesPath: 'isp',
};

export const SIGNUP_PATH = {
	privateLabelPath: 'pl-fast-path',
};

export const SIGNUP_STEPS = {
	dealership: 'dealership',
	user: 'user',
	duplicateDealership: 'duplicate_dealership',
	duplicateUser: 'duplicate_user',
};

export const SIGNUP_ENTITIES = {
	dealership: 0,
	user: 1,
};
